import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, Offcanvas, OffcanvasHeader, OffcanvasBody } from 'reactstrap';
import EditUser from './EditUser';
import Pagination from './Pagination';

const AllUsers = ({ searchQuery = '', filters = {}, status = 'all' }) => {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.junctionverse.com';
  const toggleCanvas = () => setIsOpen(!isOpen);

  const fetchUsers = async (page = 1) => {
    try {
      setLoading(true);
      const params = {
        page,
        limit: 50,
      };

      // Add status filter if provided
      if (status && status !== 'all') {
        params.status = status;
      }

      // Add search query if provided
      if (searchQuery) {
        params.search = searchQuery;
      }

      const response = await axios.get(`${API_BASE_URL}/admin/users`, {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });
      
      if (response.data.data && response.data.pagination) {
        setUsers(response.data.data);
        setPagination(response.data.pagination);
      } else {
        // Fallback for old API format
        setUsers(Array.isArray(response.data) ? response.data : []);
        setPagination(null);
      }
    } catch (err) {
      console.error('Failed to fetch users:', err);
      setError('Failed to fetch users');
    } finally {
      setLoading(false);
    }
  };

  const handleView = (user) => {
    setSelectedUser(user);
    setIsOpen(true);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchUsers(page);
  };

  // Reset to page 1 when search or status change
  useEffect(() => {
    setCurrentPage(1);
    fetchUsers(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery, status]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div>
      <table style={{ width: '100%', marginTop: '20px', borderCollapse: 'collapse' }}>
        <thead style={{
          backgroundColor: 'rgb(250, 248, 255)',
          borderTop: '1px solid rgb(233, 230, 241)',
          borderBottom: '1px solid rgb(233, 230, 241)',
        }}>
          <tr className='link-row border-bottom'>
            <th className="p-3 text-center">Full Name</th>
            <th className="p-3 text-center">Email</th>
            <th className="p-3 text-center">User Type</th>
            <th className="p-3 text-center">Onboarded</th>
            <th className="p-3 text-center">Created</th>
            <th className="p-3 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan="6" className="text-center">No users found</td>
            </tr>
          ) : (
            users.map(user => (
              <tr key={user.id} className="link-row border-bottom">
                <td className="p-2 text-center">{user.fullName}</td>
                <td className="p-2 text-center">{user.email}</td>
                <td className="p-2 text-center">{user.userType}</td>
                <td className="p-2 text-center">{user.isOnboarded ? 'Yes' : 'No'}</td>
                <td className="p-2 text-center">{new Date(user.createdAt).toLocaleDateString()}</td>
                <td className="p-2 text-center">
                  <button  className="btn btn-sm btn-outline-primary" onClick={() => handleView(user)}>View</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {pagination && (
        <Pagination pagination={pagination} onPageChange={handlePageChange} />
      )}

      {/* Offcanvas for User Display */}
      <Offcanvas isOpen={isOpen} toggle={toggleCanvas} className="custom-canvas-width" direction="end">
        <OffcanvasHeader toggle={toggleCanvas}>
          <span className='font-weight-bold'>User Info</span>
        </OffcanvasHeader>
        <OffcanvasBody>
          {selectedUser && (
            <EditUser user={selectedUser} onClose={toggleCanvas} onSuccess={() => fetchUsers(currentPage)} />
          )}
        </OffcanvasBody>
      </Offcanvas>
    </div>
  );
};

export default AllUsers;
